import axios from "axios";

// Prefer the page's own origin when running in the browser — this avoids CORS
// errors whenever the deployment URL differs from the build-time
// REACT_APP_BACKEND_URL (e.g., a fresh preview URL after redeploy). The
// Kubernetes ingress routes `/api/*` to the backend service on the same domain.
const BACKEND_URL =
  (typeof window !== "undefined" && window.location && window.location.origin)
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmtINR = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(Number(n));
  // Indian numbering format
  const formatted = abs.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  return `${sign}₹${formatted}`;
};

export const fmtPct = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(2)}%`;
};

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "2-digit" });
  } catch {
    return s;
  }
};
